import {
  isDateRangeFilter,
  setDateValidationErrors,
} from '@user/components/Filters'

import {
  FunnelFilterType,
  SalesFunnelFilterSet,
} from '@user/store/salesFunnelSummary/filters'
import { FormikErrors } from 'formik'

export function validateSalesFunnelFilters(values: SalesFunnelFilterSet) {
  const { filters } = values

  const errors: FormikErrors<SalesFunnelFilterSet> = {}
  for (const filter in filters) {
    if (isDateRangeFilter<FunnelFilterType>(filters[filter])) {
      setDateValidationErrors(filters[filter], errors)
    }
  }

  return errors
}
